import {filterSearch} from './filterSearch'

import type {Property} from 'src/services/rest'

interface Props {
  parameters: readonly Property[]
  search: string
  modifyOnly: boolean
  original: Record<string, string>
}

export function filterParameters(props: Props) {
  const {parameters, search, original, modifyOnly} = props

  return filterSearch({
    parameters: parameters.filter(
      parameter =>
        !modifyOnly || (parameter.name != null && parameter.value !== original[parameter.name]),
    ),
    search,
    original,
  })
}
